import React from 'react';

export default function DisplayDate({text}) {
  let newPaddedDate;
  try {
    let dateObj = new Date(text);
    const month   = dateObj.getUTCMonth() + 1; // months from 1-12
    const day     = dateObj.getUTCDate();
    const year    = dateObj.getUTCFullYear();
    const pMonth        = month.toString().padStart(2,"0");
    const pDay          = day.toString().padStart(2,"0");
    newPaddedDate = `${pMonth}/${pDay}/${year}`;
  } catch (e) {
    newPaddedDate = text;
  }

  return text ? <h4 style={{marginTop: '0'}}>{newPaddedDate}</h4> : null;
}
